/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import TimeBadge from 'solis/claude/element/time.badge';


export default () =>
{
  const route = use(Route);

  const board = use(Galaxy).getBoard(route.getArg('id'));

  return <TimeBadge date = {board.cass.destroyDate} />;
};
